import React from 'react';
import { Editor, Frame } from '@craftjs/core';
import { makeStyles } from '@material-ui/core/styles';

import { Container } from '../EditorNuevo/components/selectors/Container';
import { Text } from '../EditorNuevo/components/selectors/Text';
import { Image } from '../EditorNuevo/components/selectors/Image';
import { Signature } from '../EditorNuevo/components/selectors/Signature';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    overflow: 'hidden',
  },
  scaledWrapper: {
    width: '300%',
    height: '300%',
    transform: 'scale(0.333)',
    transformOrigin: 'top left',
  },
});

export const TemplatePreview = ({ content }) => {
  const classes = useStyles();

  if (!content) {
    return <div>No hay contenido para previsualizar.</div>;
  }
  
  let jsonContent;
  try {
    jsonContent = JSON.parse(content);
  } catch (e) {
    console.error("Error al parsear el contenido de la preview:", e);
    return <div>Error en la preview.</div>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.scaledWrapper}>
        <Editor
          resolver={{ Container, Text, Image, Signature }}
          enabled={false} 
        >
          <Frame data={jsonContent}> 
          </Frame>
        </Editor>
      </div>
    </div>
  );
};